import React from "react";
import "./Contact.css"; // External CSS file for styling

function Contact() {
  return (
    <div className="contact-container">
      <h2>Contact</h2>
      <p>For all enquiries please email: </p>
      <a href="mailto:thefutsaldirectory@gmail.com">
        thefutsaldirectory@gmail.com
      </a>
    </div>
  );
}

export default Contact;
